module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-3 pt-5 bg-white"
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isUpdated) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', {
    staticClass: "text-left pl-3"
  }, [_vm._v("修改密碼")]), _vm._v(" "), _c('form', {
    staticClass: "form-custom pt-0 bg-white"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputOldPassword"
    }
  }, [_vm._v("舊密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old_password),
      expression: "old_password"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "password",
      "placeholder": '輸入舊密碼...',
      "required": ""
    },
    domProps: {
      "value": (_vm.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.old_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputNewPassword"
    }
  }, [_vm._v("新密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "password",
      "placeholder": '輸入新密碼...',
      "required": ""
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputNewPassword"
    }
  }, [_vm._v("確認新密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_new_password),
      expression: "confirm_new_password"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "password",
      "placeholder": '再次輸入新密碼...',
      "required": ""
    },
    domProps: {
      "value": (_vm.confirm_new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block mt-5",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.update()
      }
    }
  }, [_vm._v("確定修改")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消修改")])])]) : _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', {
    staticClass: "text-left pl-3"
  }, [_vm._v("恭喜!")]), _vm._v(" "), _c('form', {
    staticClass: "form-custom pt-0 bg-white"
  }, [_c('label', {
    staticClass: "text-left mt-3",
    staticStyle: {
      "line-height": "300%"
    }
  }, [_vm._v("您已成功修改您的密碼，請點選下方按鈕，並使用新密碼重新登入。")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block mt-5",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.relogin()
      }
    }
  }, [_vm._v("重新登入系統")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-sm-none d-md-block col-md-4 mt-5"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/pic_calling_man.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46ebd434!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Password.vue
// module id = 720
// module chunks = 1